import type { ConfigType } from 'dayjs';
import dayjs from 'dayjs';
import { parseDateToTS } from './index';
import duration from 'dayjs/plugin/duration';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.locale('ru');
dayjs.extend(duration);
dayjs.extend(quarterOfYear);
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export type LibInput = ConfigType;
export type DateLib = typeof dayjs;

export type IUniversalDate = string | number | Date | DateStr;

export const localeSettings = Object.freeze({
    dateFormat: 'DD.MM.YYYY',
    QDateMask: 'DD.MM.YYYY',
    reportTemplateDateFormat: 'DD.MM.YYYY',
    QDateMaskWithTime: 'DD.MM.YYYY HH:mm',
    monthFormat: 'MM.YYYY',
    monthStringFormat: 'MMMM YYYY',
    dateTimeFormat: 'DD.MM.YYYY HH:mm',
    dateMask: '##.##.####',
    dateTimeMask: '##.##.#### ##:##',
    monthMask: '##.####',
    serverDateFormat: 'YYYY-MM-DD',
});

export function convertDatesToTS(
    dateStart: IUniversalDate | null,
    dateEnd: IUniversalDate | null
): [number, number] | [] {
    if (!dateStart || !dateEnd) return [];
    let date_start: number | null, date_end: number | null;
    if (typeof dateStart === 'string' || dateStart instanceof Date) date_start = parseDateToTS(dateStart);
    else date_start = dateStart;
    if (typeof dateEnd === 'string' || dateEnd instanceof Date) date_end = parseDateToTS(dateEnd);
    else date_end = dateEnd;
    return [date_start, date_end];
}

export function isDateStr(input: unknown): input is DateStr {
    return typeof input === 'string' && input.length === 10 && input.includes('-') && /^\d{4}-\d{2}-\d{2}$/.test(input);
}
